<template>
    <div>

        <menu-bar/>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a href="#/">INICIAL</a></li>
                    <li class="active">EMPRESAS</li>
                </ol>


                <div class="col-md-3">
                    <menu-empresa/>
                </div>
                <div class="col-md-9">

                    <div class="col-md-12">
                        <label class="control-label">BUSCA POR NOME DA EMPRESA</label>
                        <input type="text" v-model="nome" class="form-control" >
                    </div>

                    <div class="col-md-12" style="margin-top: 20px">

                        <table id="mytable" class="table table-bordred table-striped">

                            <thead>
                                <tr>
                                    <th>EMPRESA</th>
                                    <th style="text-align: center;width: 140px">AÇÕES</th>
                                </tr>
                            </thead>

                            <tbody>

                                <tr v-for="r in getContratos">
                                    <td>{{r.nome}}</td>
                                    <td style="text-align: center">
                                        <a :href="'#/empresa/' + r._id" class="btn btn-primary btn-xs">ABRIR</a>
                                        <button @click="excluir(r._id)" class="btn btn-danger btn-xs">EXCLUIR</button>
                                    </td>
                                </tr>

                            </tbody>

                        </table>

                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { Config, Usuario } from "../../class/index";
import MenuEmpresa from "../../menus/empresa.vue";

export default {
    components: {
        MenuEmpresa
    },
    data() {
        return {
            contratos: [],
            user: null,
            nome: null
        };
    },
    computed: {
        getContratos: function() {
            if (!this.nome) {
                return this.contratos;
            }

            return this.contratos.filter(player => {
                return player.nome
                    .toLowerCase()
                    .includes(this.nome.toLowerCase());
            });
        }
    },
    methods: {
        excluir(id) {
            swal.queue([
                {
                    title: "Contratos",
                    confirmButtonText: "Excluir Contrato",
                    text: "Posso excluir o contrato?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            Config.remove(id)
                                .then(() => {
                                    this.load();
                                    resolve();
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        },
        load() {
            Config.all()
                .then(rows => (this.contratos = rows))
                .catch(err => console.log(err));
        }
    },
    beforeRouteEnter(to, from, next) {
        Usuario.level()
            .then(data => {
                if (data.level === 0) {
                    return next();
                }
                window.location.href = Vue.http.options.root;
            })
            .catch(err => {
                window.location.href = Vue.http.options.root;
            });
    },
    beforeMount() {
        this.user = this.$store.state.user;
        this.load();
    }
};
</script>
